import { AppHeader } from "../../components/AppHeader";
import { AppFooter } from "../../components/AppFooter";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useIsMobile } from "../../hooks/useIsMobile";

export function TermsPage() {
  usePageTitle("이용약관");
  const m = useIsMobile();

  return (
    <div style={st.page}>
      <AppHeader />
      <div style={{ ...st.container, padding: m ? "24px 16px 60px" : "40px 32px 80px" }}>
        <div style={st.header}>
          <h1 style={st.mainTitle}>{"이용약관"}</h1>
          <p style={st.subtitle}>{"Terms of Service"}</p>
          <p style={st.updated}>{"최종 업데이트: 2026년 3월 1일"}</p>
        </div>

        <Section title="제1조 (목적)">
          <p>{"이 약관은 genomic.cc(이하 '운영자')가 운영하는 땅신뢰 LandTrust(이하 '서비스')의 이용 조건 및 절차, 운영자와 이용자의 권리·의무 및 책임 사항, 기타 필요한 사항을 규정함을 목적으로 합니다."}</p>
          <p>{"서비스는 공인중개사 자격증 보유자(이하 '회원') 간의 토지·임야 매물 정보를 공유하는 블라인드 MLS(다중상장서비스) 플랫폼으로, 매물 정보 공개 범위를 NDA(비밀유지계약) 동의 여부에 따라 단계적으로 제공합니다."}</p>
        </Section>

        <Section title="제2조 (정의)">
          <ul style={st.defList}>
            <li><strong>{"서비스:"}</strong>{" 운영자가 제공하는 땅신뢰(LandTrust) 플랫폼 전체를 의미합니다."}</li>
            <li><strong>{"회원:"}</strong>{" 공인중개사 자격증을 보유하고 서비스에 가입한 자를 의미합니다."}</li>
            <li><strong>{"블라인드 매물:"}</strong>{" 정확한 주소 및 소유자 정보는 NDA 동의 후에만 공개되는 매물을 의미합니다."}</li>
            <li><strong>{"NDA(비밀유지계약):"}</strong>{" 비공개 매물 정보의 열람 전 서면 동의로, 정보 유출 시 법적 책임을 부담하는 계약입니다."}</li>
            <li><strong>{"신뢰도 점수:"}</strong>{" 회원의 서비스 이용 행태, NDA 준수 여부 등을 종합하여 산정하는 점수입니다."}</li>
          </ul>
        </Section>

        <Section title="제3조 (회원 가입 자격 및 절차)">
          <p>{"① 서비스 회원 가입은 국가공인 공인중개사 자격증 보유자로 한정합니다."}</p>
          <p>{"② 회원 가입 시 자격증 번호, 사무소명, 실명, 휴대폰 번호를 정확하게 입력하여야 합니다."}</p>
          <p>{"③ 허위 정보로 가입한 경우 즉시 계정이 정지되며, 열람한 매물 정보에 대한 비밀유지 의무는 계속 존속합니다."}</p>
          <p>{"④ 운영자는 가입 신청을 거절하거나, 기존 회원의 자격을 정지·박탈할 수 있습니다."}</p>
        </Section>

        <Section title="제4조 (서비스 이용)">
          <p>{"① 회원은 서비스를 통해 다음 기능을 이용할 수 있습니다."}</p>
          <ul style={st.list}>
            <li>{"블라인드 매물 등록 (정확한 주소는 비공개 처리)"}</li>
            <li>{"매물 목록 조회 및 검색 (블라인드 위치 기반)"}</li>
            <li>{"NDA 동의 후 매물 상세 정보 열람 (정확한 주소, 소유자 연락처)"}</li>
            <li>{"중개사 간 매물 문의"}</li>
            <li>{"관심 매물 저장"}</li>
          </ul>
          <p>{"② 서비스는 중개사 간 정보 공유 플랫폼이며, 운영자는 중개 행위의 직접 당사자가 아닙니다."}</p>
        </Section>

        <Section title="제5조 (NDA 및 비밀유지 의무)">
          <Callout>{"⚠️ NDA 조항은 서비스의 핵심입니다. 위반 시 법적 책임이 따릅니다."}</Callout>
          <p>{"① 회원은 NDA 동의를 통해 열람한 비공개 정보(정확한 주소, 지번, 소유자 연락처 등)를 다음과 같이 사용하여야 합니다."}</p>
          <ul style={st.list}>
            <li>{"매물 검토 및 정상적인 중개 목적으로만 사용"}</li>
            <li>{"제3자(타 플랫폼, 개인 SNS, 지인 등)에게 누설, 공개, 유출 금지"}</li>
            <li>{"캡처, 복사, 저장 후 외부 공유 행위 금지"}</li>
            <li>{"소유자에게 무단 직접 접촉 금지 (해당 매물의 담당 중개사를 통해야 함)"}</li>
          </ul>
          <p>{"② NDA 위반이 확인되는 경우 운영자는 다음 조치를 취할 수 있습니다."}</p>
          <ul style={st.list}>
            <li>{"신뢰도 점수 대폭 감점"}</li>
            <li>{"서비스 이용 정지 또는 영구 탈퇴 처리"}</li>
            <li>{"손해배상 청구"}</li>
          </ul>
          <p>{"③ NDA 동의 후 열람한 정보에 대한 비밀유지 의무는 회원 탈퇴 이후에도 5년간 존속합니다."}</p>
        </Section>

        <Section title="제6조 (매물 정보의 정확성 및 책임)">
          <p>{"① 매물을 등록한 중개사(이하 '등록 중개사')는 매물 정보의 정확성에 책임을 집니다."}</p>
          <p>{"② 운영자는 등록된 매물 정보의 사실 여부를 보증하지 않습니다."}</p>
          <p>{"③ 허위·과장 매물을 등록한 경우 해당 중개사의 신뢰도 점수가 감점되며, 서비스 이용이 제한될 수 있습니다."}</p>
          <p>{"④ 매물 정보를 열람한 회원은 계약 전 반드시 현장 확인 및 공부 조회를 통해 사실 여부를 직접 확인하여야 합니다."}</p>
        </Section>

        <Section title="제7조 (운영자의 면책)">
          <p>{"① 운영자는 서비스를 통해 중개된 거래의 결과, 계약 분쟁, 권리 하자, 재정적 손실 등에 대해 책임을 지지 않습니다."}</p>
          <p>{"② 운영자는 회원 간의 분쟁에 개입하지 않으며, 분쟁 해결의 책임은 당사자에게 있습니다."}</p>
          <p>{"③ 천재지변, 서비스 장애, 해킹 등 불가항력적 사유로 인한 서비스 중단에 대해 운영자는 책임을 지지 않습니다."}</p>
        </Section>

        <Section title="제8조 (금지 행위)">
          <p>{"회원은 다음 행위를 하여서는 안 됩니다."}</p>
          <ul style={st.list}>
            <li>{"타인의 계정을 사용하거나 타인 명의로 가입하는 행위"}</li>
            <li>{"서비스를 통해 취득한 정보를 상업적으로 악용하는 행위"}</li>
            <li>{"서비스 시스템을 무단으로 크롤링·스크래핑하는 행위"}</li>
            <li>{"허위 매물을 등록하거나 시세를 교란하는 행위"}</li>
            <li>{"NDA를 위반하여 비공개 정보를 유출하는 행위"}</li>
            <li>{"운영자 또는 다른 회원에게 욕설, 비방, 위협적 언동을 하는 행위"}</li>
          </ul>
        </Section>

        <Section title="제9조 (서비스 변경 및 중단)">
          <p>{"① 운영자는 서비스 내용을 변경하거나 중단할 수 있으며, 사전에 서비스 내 공지를 통해 안내합니다."}</p>
          <p>{"② 서비스 운영에 필요한 경우, 정기 또는 임시 점검을 실시할 수 있습니다."}</p>
          <p>{"③ 무료 서비스의 경우, 이용 중단에 따른 별도 보상은 제공되지 않습니다."}</p>
        </Section>

        <Section title="제10조 (신뢰도 점수 제도)">
          <p>{"① 운영자는 회원의 서비스 이용 행태에 따라 신뢰도 점수를 부여·조정합니다."}</p>
          <p>{"② 신뢰도 점수는 다음 요인에 의해 변동될 수 있습니다."}</p>
          <ul style={st.list}>
            <li>{"자격증 인증 완료: 점수 상승"}</li>
            <li>{"NDA 위반 확인: 점수 대폭 하락"}</li>
            <li>{"운영자의 수동 조정: 상황에 따라"}</li>
          </ul>
          <p>{"③ 신뢰도 점수는 서비스 내에서 다른 회원에게 공개될 수 있습니다."}</p>
        </Section>

        <Section title="제11조 (개인정보 보호)">
          <p>{"운영자는 「개인정보 보호법」에 따라 이용자 개인정보를 보호하며, 자세한 사항은 별도의 '개인정보 처리방침'에 따릅니다."}</p>
        </Section>

        <Section title="제12조 (준거법 및 관할법원)">
          <p>{"① 본 약관은 대한민국 법률에 따라 해석되고 적용됩니다."}</p>
          <p>{"② 서비스 이용으로 발생한 분쟁에 관한 소송은 대구지방법원을 제1심 관할법원으로 합니다."}</p>
        </Section>

        <Section title="제13조 (약관 변경)">
          <p>{"운영자는 약관을 변경할 수 있으며, 변경 시 적용일 7일 이전부터 서비스 내 공지사항에 게시합니다. 변경 약관의 효력 발생일 이후에도 서비스를 계속 이용하는 경우 변경 약관에 동의한 것으로 간주합니다."}</p>
        </Section>

        <Section title="부칙">
          <p>{"본 약관은 2026년 3월 1일부터 시행됩니다."}</p>
        </Section>
      </div>
      <AppFooter />
    </div>
  );
}

// ── 서브 컴포넌트 ──────────────────────────────────────
function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={st.section}>
      <h2 style={st.sectionTitle}>{title}</h2>
      <div style={st.sectionBody}>{children}</div>
    </div>
  );
}

function Callout({ children }: { children: React.ReactNode }) {
  return (
    <div style={st.callout}>{children}</div>
  );
}

// ── 스타일 ──────────────────────────────────────
const gold = "#D4A853";
const st: Record<string, React.CSSProperties> = {
  page: { minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg-primary)" },
  container: { maxWidth: 1200, margin: "0 auto", flex: 1 },
  header: { textAlign: "center", marginBottom: 40, paddingBottom: 28, borderBottom: "1px solid var(--border-light)" },
  mainTitle: { fontSize: 30, fontWeight: 900, color: "var(--text-primary)", margin: "0 0 8px" },
  subtitle: { fontSize: 15, color: "var(--text-muted)", margin: "0 0 8px" },
  updated: { fontSize: 13, color: "var(--text-muted)", margin: 0 },
  section: { marginBottom: 32 },
  sectionTitle: {
    fontSize: 16, fontWeight: 700, color: gold,
    padding: "10px 16px", margin: "0 0 14px",
    background: "rgba(212,168,83,0.08)",
    borderLeft: `3px solid ${gold}`,
    borderRadius: "0 8px 8px 0",
  },
  sectionBody: { paddingLeft: 4, lineHeight: "1.8", color: "var(--text-secondary)", fontSize: 14 },
  list: { margin: "8px 0", paddingLeft: 20, display: "flex", flexDirection: "column", gap: 6 },
  defList: { margin: "8px 0", paddingLeft: 20, display: "flex", flexDirection: "column", gap: 10 },
  callout: {
    background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.25)",
    borderRadius: 8, padding: "10px 14px",
    color: "#EF4444", fontSize: 13, fontWeight: 600,
    marginBottom: 12,
  },
};
